import { FC, useState } from 'react';
import { Icon, Button } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../../Localization';
import { InfoFieldProps } from '../shared/types';
import { MAX_TRANSCRIPT_CHARS } from './MessageBubble/shared/constants';

/**
 * Reusable component for displaying a label/value pair with optional verified icon
 */
export const InfoField: FC<InfoFieldProps> = ({ label, value, verified }) => {
  const L = useLocalizedStrings();
  const [isExpanded, setIsExpanded] = useState(false);

  const shouldTruncate = typeof value === "string" && value.length > MAX_TRANSCRIPT_CHARS;
  const displayText = shouldTruncate && !isExpanded ? value.slice(0, MAX_TRANSCRIPT_CHARS) : value;

  return (
    <div className="min-w-0">
      <div className="text-sm font-medium text-gray-900 break-words overflow-wrap-anywhere">{label}</div>
      <div className="text-base text-gray-600 mt-1 flex items-center gap-2 min-w-0">
        <span className="text-sm break-words overflow-wrap-anywhere min-w-0">
          "{displayText}{shouldTruncate && !isExpanded && "..."}"
          {shouldTruncate && (
            <>
              {" "}
              <Button
                variant="link"
                onClick={() => setIsExpanded(!isExpanded)}
              >
                {isExpanded ? L.applicant.comms.show_less : L.applicant.comms.show_more}
              </Button>
            </>
          )}
        </span>
        {verified && (
          <Icon role="decorative" type="solid" name="CheckCircleIcon" className="w-5 h-5 text-green-600 flex-shrink-0" />
        )}
      </div>
    </div>
  );
};
